import React from "react";
import HeaderWithSearch from "./HeaderWithSearch";
import ImageWithFallback from "./ImageWithFallback";

function ChilliButterPasta() {
  return (
    <>
      <HeaderWithSearch />
      <main
        style={{
          minHeight: "100vh",
          width: "100%",
          background: "linear-gradient(180deg, #e3f0fc 0%, #fafdff 100%)",
          padding: 0,
          margin: 0,
        }}
      >
        <section
          className="recipe-hero-anim"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "60vh",
            padding: "60px 20px 40px 20px",
          }}
        >
          <h1
            className="recipe-title-anim"
            style={{
              fontSize: "3rem",
              fontWeight: "bold",
              marginBottom: 16,
              textAlign: "center",
            }}
          >
            Chilli Butter Pasta
          </h1>
          <span className="season-badge season-winter" style={{ marginBottom: 24 }}>❄️ Best in Winter</span>
          <ImageWithFallback
            src="/buttered_pasta.png"
            alt="Chilli Butter Pasta"
            className="recipe-image-anim"
            style={{
              width: 400,
              height: 300,
              objectFit: "cover",
              borderRadius: 24,
              boxShadow: "0 4px 32px rgba(0,0,0,0.10)",
              marginBottom: 32,
            }}
          />
          <div
            style={{
              maxWidth: 800,
              fontSize: "1.1rem",
              color: "#333",
              lineHeight: 1.8,
            }}
          >
            <h2 style={{ fontSize: "1.5rem", fontWeight: 600, marginBottom: 16 }}>
              Ingredients:
            </h2>
            <ul className="ingredient-list" style={{ marginBottom: 24, paddingLeft: 20 }}>
              <li>250g pasta (penne, fusilli, or spaghetti)</li>
              <li>3 tbsp butter</li>
              <li>2 tbsp olive oil</li>
              <li>4-5 garlic cloves, minced</li>
              <li>2-3 green chilies, finely chopped</li>
              <li>1 tsp red chili flakes</li>
              <li>1/2 tsp black pepper powder</li>
              <li>Salt to taste</li>
              <li>1/4 cup pasta water (reserved)</li>
              <li>2 tbsp fresh parsley or coriander, chopped</li>
              <li>1/4 cup parmesan cheese, grated (optional)</li>
              <li>1 tsp Italian seasoning (optional)</li>
              <li>Juice of 1/2 lemon</li>
            </ul>

            <h2 style={{ fontSize: "1.5rem", fontWeight: 600, marginBottom: 16 }}>
              Instructions:
            </h2>
            <ol className="instructions-list" style={{ paddingLeft: 20 }}>
              <li style={{ marginBottom: 12 }}>
                <strong>Cook pasta:</strong> Bring a large pot of salted water to boil. Add pasta and cook according to package directions until al dente. Reserve 1/4 cup pasta water before draining.
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Prepare sauce:</strong> While pasta is cooking, heat butter and olive oil in a large pan over medium heat.
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Add aromatics:</strong> Add minced garlic and chopped green chilies. Sauté for 1-2 minutes until fragrant, being careful not to burn the garlic.
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Add spices:</strong> Add red chili flakes, black pepper powder, and salt. Stir for 30 seconds.
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Combine pasta:</strong> Add the drained pasta to the pan and toss well to coat with the butter sauce.
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Adjust consistency:</strong> Add reserved pasta water gradually if needed to create a silky sauce that coats the pasta.
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Season:</strong> Add Italian seasoning if using, and squeeze lemon juice over the pasta. Toss well.
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Finish and serve:</strong> Remove from heat, add fresh parsley or coriander and toss. Serve hot, topped with grated parmesan cheese if desired.
              </li>
            </ol>

            <div
              className="chef-tips-box"
              style={{
                background: "#f8f9fa",
                padding: 20,
                borderRadius: 12,
                marginTop: 24,
              }}
            >
              <h3 style={{ fontSize: "1.3rem", fontWeight: 600, marginBottom: 12 }}>
                <span className="tip-icon" role="img" aria-label="chef">👨‍🍳</span> Chef's Tips:
              </h3>
              <ul style={{ paddingLeft: 20 }}>
                <li>Don't overcook pasta - al dente texture works best</li>
                <li>Reserved pasta water helps create a creamy sauce</li>
                <li>Adjust chili quantity based on your spice preference</li>
                <li>Add vegetables like bell peppers or broccoli for extra nutrition</li>
                <li>For extra richness, add a splash of cream</li>
                <li>Serve immediately for best taste and texture</li>
              </ul>
            </div>

            <div
              className="health-benefits-box"
              style={{
                background: "#eef9f0",
                padding: 20,
                borderRadius: 12,
                marginTop: 24,
              }}
            >
              <h3 style={{ fontSize: "1.3rem", fontWeight: 600, marginBottom: 12 }}>
                <span className="tip-icon" role="img" aria-label="health">🌿</span> Health Benefits
              </h3>
              <ul style={{ paddingLeft: 20 }}>
                <li>Garlic and chili have warming, circulation-boosting properties valued in many cuisines.</li>
                <li>Using olive oil alongside butter adds some heart-healthy monounsaturated fat.</li>
                <li>Tossing in extra vegetables like broccoli or bell peppers easily boosts the fiber and vitamin content.</li>
                <li>A squeeze of lemon at the end adds vitamin C and brightens the dish without extra salt.</li>
              </ul>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

export default ChilliButterPasta;